<script setup lang="ts">
defineProps<{ paths: readonly string[] }>()
</script>

<template>
  <svg
    class="shrink-0"
    viewBox="0 0 16 16"
    width="16"
    height="16"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path v-for="d in paths" :key="d" :d="d" />
  </svg>
</template>
